<template>
  <div
    class="sidebar"
    :data-color="activeColor"
    :data-image="backgroundImage"
    :data-background-color="backgroundColor"
    :style="sidebarStyle"
  >
    <div class="logo">
      <a
        href="#"
        class="simple-text logo-mini"
        target="_self"
      >
        <!-- <div class="logo-img">
          <img :src="logo" />
        </div> -->
        <md-icon>menu</md-icon>
      </a>
      <a
        href="#"
        class="simple-text logo-normal"
        target="_self"
      >
        <template v-if="$route.meta.rtlActive">{{ rtlTitle }}</template>
        <template v-else>{{ title }}</template>
      </a> 
      <div class="navbar-minimize">
        <md-button
          id="minimizeSidebar"
          class="md-round md-just-icon md-transparent"
          @click="minimizeSidebar"
        >
          <i class="material-icons text_align-center visible-on-sidebar-regular"
            >more_vert</i
          >
          <i
            class="material-icons design_bullet-list-67 visible-on-sidebar-mini"
            >push_pin</i
          >
        </md-button>
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <slot></slot>
      <md-list class="nav">
        <slot name="links">
          <sidebar-item
            v-for="(link, index) in sidebarLinks"
            :key="link.name + index"
            :link="link"
          >
            <sidebar-item
              v-for="(subLink, index) in link.children"
              :key="subLink.name + index"
              :link="subLink"
            >
            </sidebar-item>
          </sidebar-item>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "MENU"
    },
    rtlTitle: {
      type: String,
      default: "توقيت الإبداعية"
    },
    activeColor: {
      type: String,
      default: "blue",
      validator: value => {
        let acceptedValues = [
          "",
          "blue",
          "purple",
          "azure",
          "green",
          "orange",
          "danger",
          "rose"
        ];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundImage: {
      type: String,
      default: require("../../assets/img/sidebar-2.jpg")
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: value => {
        let acceptedValues = ["", "black", "white", "red"];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: require("../../assets/img/zink-logo-colour-white.png")
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide() {
    return {
      autoClose: this.autoClose
    };
  },
  beforeMount() {
      this.minimizeSidebar();
  },
  methods: {
    minimizeSidebar() {
      if (this.$sidebar) {
        this.$sidebar.toggleMinimize();
      }
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      };
    }
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
};
</script>
<style lang="scss">
@import '../../assets/scss/theme.scss';
@import '../../assets/scss/md-custom/_ausloans-colors.scss';
/* Sidebar colour scheme */
.sidebar, .off-canvas-sidebar,.sidebar:after, .off-canvas-sidebar:after {
    background-color: $ausloans-blue-dark !important;
}
.sidebar.ps {
    background-image: inherit !important;
}
.sidebar .nav li:hover > a, .sidebar .nav li .dropdown:hover > a, .off-canvas-sidebar .nav li:hover > a, .off-canvas-sidebar .nav li .dropdown:hover > a {
    background: $ausloans-blue-light !important;
}
.sidebar[data-color=blue] li.active > a:not([data-toggle=collapse]), .off-canvas-sidebar[data-color=blue] li.active > a:not([data-toggle=collapse]) {
    background-color: $ausloans-blue !important;
    box-shadow: inherit !important;
    //0 12px 20px -10px rgba(234, 234, 234, 0.2), 0 4px 20px 0px rgba(0, 0, 0, 0.12), 0 7px 8px -5px rgba(234, 234, 234, 0.2) !important;
}
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
</style>
